import { render, staticRenderFns } from "./RelatorioAmortizacaoRetrato.vue?vue&type=template&id=12b8d2a6"
import script from "./RelatorioAmortizacaoRetrato.vue?vue&type=script&lang=js"
export * from "./RelatorioAmortizacaoRetrato.vue?vue&type=script&lang=js"
import style0 from "./RelatorioAmortizacaoRetrato.vue?vue&type=style&index=0&id=12b8d2a6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports